import { isCNHost } from "./isCNHost";

function computeInternationalAIChatBaseURL(){
  const {hostname} = window.location;
  if(hostname.indexOf("-stg") > 0){
    return "https://cloudapi-stg.foxitcloud.com"
  }

  if(hostname.indexOf("foxit.com") > 0){
    return ""
  }

  return "https://cloudapis-azk8s.foxitcloud.com"
}

function computeCNAIChatBaseURL(){
  const {hostname} = window.location;
  if(hostname.indexOf("-stg") > 0){
    return "https://cloudapi-stgcn.connectedpdf.com"
  }
  if(hostname.indexOf("fuxinsoft.cn") > 0){
    return "https://cloudapi.fuxinsoft.cn"
  }

  return "https://cloudapi-devcn.connectedpdf.com"
}

export function computeAIChatURL(){
  if(isCNHost){
    return `${computeCNAIChatBaseURL()}/studio/sdk-ai-assistant?platform=WebSDK`
  }
  return `${computeInternationalAIChatBaseURL()}/ai-assistant/?ref=websdk_demo`
}
